import { create } from 'zustand';
import { getStoredDeveloperMode, setStoredDeveloperMode } from '../utils/developer-mode';

interface DeveloperStore {
  /**
   * Modalita' sviluppatore a runtime, accesa da dieci tocchi sul copyright del
   * footer. Sta qui — fuori da LegalFooter — perche' il footer e' montato da due
   * rami diversi del render di App e perche' il valore deve restare leggibile
   * anche fuori da React: useDeveloperStore.getState().isDeveloper.
   *
   * Rispecchiata in localStorage (utils/developer-mode.ts) cosi' sopravvive a un
   * reload. Niente middleware `persist`: quello scrive un envelope
   * {state,version} che renderebbe scomodo leggere il flag da un chiamante non
   * React, ed e' riservato ai payload veri (preferences-store, auth-store).
   */
  isDeveloper: boolean;
  setDeveloper: (on: boolean) => void;
  toggleDeveloper: () => void;
}

export const useDeveloperStore = create<DeveloperStore>((set, get) => ({
  // Letto una volta sola al caricamento del modulo: nessuno cambia la chiave
  // alle spalle dell'app, e da qui in poi lo store e' l'unica sorgente per la UI.
  isDeveloper: getStoredDeveloperMode(),
  setDeveloper: (isDeveloper) => {
    setStoredDeveloperMode(isDeveloper);
    set({ isDeveloper });
  },
  toggleDeveloper: () => { get().setDeveloper(!get().isDeveloper); },
}));
